import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("path", {
              fill: "#252729",
              d: "M47.828 16.25c.415 0 .75.336.75.75 0 .38-.282.693-.648.743l-.102.007h-16c-.414 0-.75-.336-.75-.75 0-.38.283-.693.649-.743l.101-.007h16zm0-5c.415 0 .75.336.75.75 0 .38-.282.693-.648.743l-.102.007h-16c-.414 0-.75-.336-.75-.75 0-.38.283-.693.649-.743l.101-.007h16zm0-5c.415 0 .75.336.75.75 0 .38-.282.693-.648.743l-.102.007h-16c-.414 0-.75-.336-.75-.75 0-.38.283-.693.649-.743l.101-.007h16z",
              transform: "translate(-271 -168) translate(0 148) translate(243.172 20)"
            })
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }